import React, { useMemo } from 'react';
import {
    AssigneeToAnotherUserIcon,
    AssigneeToYouUserIcon,
    ConversationClosedIcon,
    ConversationInProgressIcon,
    ConversationOpenIcon,
    ConversationReslovedIcon,
    StarBlackIcon,
    UnAssignedIcon
} from '../../icon';
import { UserService } from '../../services/UserService';
import { UtilityService } from '../../services/UtilityService';

interface IProps {
    Message: string;
}

const AssignStatusMessage = (Props: IProps) => {

    const currentUser = UserService.getCurrentUserFromLocalStorage();
    const currentUserName = currentUser?.FullName || "";

    const { beforeTo, afterTo, Icon, color } = useMemo(() => {

        const [before = "", after = ""] = Props.Message.split(" to ");
        const statusPart = after.toLowerCase();

        const isAssign = Props.Message.includes('assigned');
        const isUnassigned = Props.Message.includes('unassigned');
        const assignedToYou = after === currentUserName;

        let IconComp = StarBlackIcon;
        let colorClass = "color-primary-accent";

        if (isUnassigned) {
            IconComp = UnAssignedIcon;
        }
        else if (isAssign) {
            IconComp = assignedToYou ? AssigneeToYouUserIcon : AssigneeToAnotherUserIcon;
            colorClass = assignedToYou ? "color-primary-light" : "color-primary-accent";
        }
        else if (statusPart.includes('inprogress') || statusPart.includes('in progress')) {
            IconComp = ConversationInProgressIcon;
            colorClass = "color-primary-light";
        }
        else if (statusPart.includes('resolved')) {
            IconComp = ConversationReslovedIcon;
        }
        else if (statusPart.includes('closed')) {
            IconComp = ConversationClosedIcon;
        }
        else if (statusPart.includes('open')) {
            IconComp = ConversationOpenIcon;
            colorClass = "color-primary-success";
        }

        return {
            beforeTo: before,
            afterTo: after,
            Icon: IconComp,
            color: colorClass
        };

    }, [Props.Message, currentUserName]);

    const formatText = (text: string) =>
        text.replace(currentUserName, "You")
            .replace("InProgress", "In-Progress")
            .replace("FollowUp", "Follow-Up");

    return (
        <div className="d-flex align-center m-1">
            <Icon className="w-3 h-3" />

            <span className="ml-1 color-conv-hist-date-day h5-regular">
                {formatText(beforeTo)}{!!afterTo && " to "}
                <span className={`ml-1 h5-semibold ${color}`}>
                    {UtilityService.trimMessage(formatText(afterTo), 20)}
                </span>
            </span>
        </div>
    );
};

export default AssignStatusMessage;